import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "padding10px" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")

  return (_ctx.isToLong)
    ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        trigger: "hover",
        width: 200
      }, {
        reference: _withCtx(() => [
          _createVNode("span", null, _toDisplayString(_ctx.limitedLocationStr), 1)
        ]),
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, _toDisplayString(_ctx.locationStr), 1)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock("label", _hoisted_2, _toDisplayString(_ctx.locationStr), 1))
}